import React from "react";

export const Level4 = (props) => {
  const { callback } = props;
  const onClick = (e) => {
    e.preventDefault();
    const num = e.currentTarget.attributes.name.nodeValue;
    callback(num);
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1927.56 1077.17">
      <defs></defs>
      <title></title>
      <g id="Capa_46" data-name="Capa 46">
        <path
          onClick={onClick}
          name="22"
          style={{ fill: "transparent" }}
          d="M492,6,483.7,181.38c-.8,16.91-.32,36.69,13.23,46.83A380.85,380.85,0,0,1,742.26,233c14.54,5.31,28.74,11.52,43.35,16.65a312.17,312.17,0,0,0,71.15,16A1201.38,1201.38,0,0,0,890.27,11.81L711.84,13.72c-25.31.28-50.7.55-75.77,4-18.65,2.59-37.14,6.94-56,7.27-28.29.48-55.85-8.13-82.83-16.67"
        />
        <path
          onClick={onClick}
          name="6"
          style={{ fill: "transparent" }}
          d="M24.26,357.9c14.25,3,2.9,8.84,14.93,17.06-1.07,25.69,3.53,53.38,21.34,71.92s51.76,22.63,68.31,2.95c15.29-18.19,6-50.76-16.53-58.19L228.86,371.1c18.82-3.32,38.1-6.8,54.58-16.47,13.4-7.86,24.29-19.48,32.94-32.37,8-12,11.83-32.3-1.66-37.37-4.29-1.62-9.07-.88-13.59-.12L238.48,295.3a173.19,173.19,0,0,1,5.12-81.43c6.61-21.24,17.4-41.62,18.64-63.83.24-4.32.05-8.88-2.13-12.62s-6-6.07-9.84-7.86c-20.59-9.51-47-4.53-62.65,11.84-5.29,5.52-9.49,12.21-15.74,16.62-6,4.22-13.26,6-20.36,7.67L88.11,180.76c-10.45,2.48-21.19,5-31.84,3.6-22-2.87-13.5-21.3-33.79-30.38-2.54-1.14-5.32-2.16-8.06-1.64C7.73,153.59,6,162.23,5.7,169q-3,80.28,0,160.61c.37,9.74,3.49,22.41,13.22,23"
        />
        <path
          onClick={onClick}
          name="13"
          style={{ fill: "transparent" }}
          d="M267,216.61l-13.37,51.73L298,263.48c9.15-1,18.61-2,27.4.75,18.84,5.86,29.07,28.42,25.21,47.77s-18.92,35-36.29,44.33-37,13.41-56.35,17.35l-112.6,23c1.61,16.08,6.17,35.79,21.86,39.72,16,4,32.43-12.28,48-6.95,6.13,2.09,10.66,7.15,15.57,11.37C249,456.34,275.57,461.27,298,453.23c11.54-4.12,21.84-11.33,33.54-15,20.06-6.25,41.79-1.46,62.69-3.63a95.11,95.11,0,0,0,60.89-31.39c5-5.7,9.79-12.33,17-14.75,5.62-1.89,11.73-.85,17.61-.09,16.73,2.16,34.31,1.76,49.66-5.21s28-21.53,29.1-38.36c1-16.08-8.17-30.82-17-44.3-27.08-41.37-56.65-84.91-102-104.67-58.59-25.56-126-4.48-186.27,16.74"
        />
        <path
          onClick={onClick}
          name="1"
          style={{ fill: "transparent" }}
          d="M520.53,409.32c-1.07,7.82-7.8,13.79-14.87,17.71s-15,6.59-21.26,11.6c-12.69,10.09-16.08,29.56-7.5,43.12,6.72,10.64,20,18.81,19.65,31.28-.23,8.08-6.45,15-7.38,23-1.69,14.6,14,25.32,28.49,29.76a124.41,124.41,0,0,0,48.83,4.84c3.26-.33,6.75-.9,9.07-3.14,2.81-2.72,3-7,3.09-10.83q.32-23.4.62-46.8c6.73,3,15-.51,19.58-6.14s6.26-12.9,7.69-19.93c4.6-22.66,7.55-46.7-.6-68.41-3.16-8.43-8.2-16.54-15.92-21.5-10-6.42-23.19-6.62-34.69-3.28s-21.69,9.84-31.7,16.25"
        />
        <path
          onClick={onClick}
          name="7"
          style={{ fill: "transparent" }}
          d="M628.64,433.81l13,4.39c1.62-9.26,10.3-12.88,16.41-9s9.91,12.65,12.58,21.4c7.91,26,9,55.17,7.93,83.47s-4,56.49-3.58,84.82c-8.57,7.08-19.22,5.41-29,3.53-2.16-.41-4.44-.91-6.1-2.93s-2.35-5.22-2.87-8.25c-6-35.13.89-72.07-1-108.13-.21-3.95-.66-8.28-2.75-10.88-1.77-2.19-4.3-2.62-6.24-4.47-3.93-3.75-4.21-11.78-3.69-18.5a163.63,163.63,0,0,1,6.18-33.63"
        />

        <path
          onClick={onClick}
          name="24"
          style={{ fill: "transparent" }}
          d="M135.49,697.64l53.06,32.51c6.8,4.16,15.37,8.39,22.27,4.4,4.89-2.84,6.84-8.74,9.28-13.84S227,710.3,232.6,711c3.26.39,6.25,2.8,9.48,2.23,2.32-.41,4.07-2.27,5.59-4.06a118,118,0,0,0,24.49-48.4,197.85,197.85,0,0,0-56.22-36.06c-2.18-.92-4.57-1.82-6.86-1.24-3.41.86-5.37,4.65-8.69,5.81-6.84,2.37-13.62-7.59-20.38-5-2.14.82-3.62,2.75-5.42,4.16-5.89,4.62-14.53,3.42-21.23,6.78-8.71,4.37-11.88,15-14.18,24.45L132,689.33"
        />
        <path
          onClick={onClick}
          name="20"
          style={{ fill: "transparent" }}
          d="M66.29,655.59l47.49-.15c2.41,0,5,0,7,1.28,2.72,1.67,3.85,5,4.71,8.07a230.37,230.37,0,0,1,8.19,50,43.61,43.61,0,0,0,19.7,9.21c5.4,1,11.05,1,16.17,3,14.25,5.6,18.32,23.52,19.93,38.75a799.1,799.1,0,0,1,3.16,129.6c-.14,2.58-.35,5.3-1.78,7.45-2.28,3.41-6.82,4.31-10.88,4.91l-79.93,11.85c-2.86.42-5.82.84-8.63.13-4-1-7.14-4.21-10-7.26L55,884.19c-3.87-4.13-7.82-8.38-10-13.59-2.64-6.26-2.51-13.28-2.34-20.06l2.14-84.07c.2-8,.51-16.3,4.57-23.14,2.46-4.15,6.14-7.45,8.79-11.48,11.25-17.14.75-40.29,5-60.35"
        />
        <path
          onClick={onClick}
          name="3"
          style={{ fill: "transparent" }}
          d="M282.81,804.61q-1.2,38.29.74,76.61c.37,7.27,1,14.95,5.11,20.95,4.87,7,13.58,10.24,20,15.94a33,33,0,0,1,8.61,35.7l65.28-1.64c1.93,12.5-15.9,16.23-27.38,21.56-21.63,10-26.61,38-28.78,61.73-1.54,16.92-2.57,35.68,7.93,49,6.77,8.6,17.35,13.4,28,16,45.54,11,91.86-13.85,138.69-14.84,31.4-.67,64.48,9.17,93.26-3.42,26.62-11.65,44-40.6,72.1-47.84,13.17-3.39,28.34-1.91,39-10.36,12.54-9.94,12.78-28.54,11.91-44.52q-2.13-39.3-4.27-78.61l-.54-10.07-5.31-97.86c-1.88-34.61-3.9-69.88-16.39-102.21-4.08-10.55-9.32-20.79-16.82-29.26-19.42-21.94-50.36-28.68-76-42.92-31.16-17.34-60.11-47.86-95.38-42.65-29.56,4.36-48.9,32.33-64.57,57.77-3.67,6-6.78,15-.94,18.83,2.18,1.44,4.95,1.5,7.51,2,11.13,2.27,18.43,13.77,19.58,25.07s-2.48,22.46-6.06,33.24c-1.28,3.85-2.94,8.12-6.67,9.71-3.1,1.32-6.66.33-9.83-.8C403,708,372.67,676.51,334,663c-6.52-2.28-13.87-4-20.18-1.18-4.32,1.93-7.55,5.77-9.68,10-11.06,22,5.88,47.61,24.25,63.93s40.79,32.61,44,57a95.77,95.77,0,0,0-79.54,12.64"
        />

        <path
          onClick={onClick}
          name="4"
          style={{ fill: "transparent" }}
          d="M741.54,496.93c26.24-4,50.58,17.39,60.9,41.85s10.61,51.75,14.46,78c.85,5.83,2,11.93,5.77,16.48s9.68,6.9,15.28,9l35.27,13.24c19.14,7.19,39.47,14.49,59.57,10.75,23.39-4.36,41.65-22.79,64.09-30.71,3.09-1.09,6.48-2.15,8.35-4.84,1.28-1.86,1.6-4.21,1.88-6.45a1069.36,1069.36,0,0,0,3.51-229.1c-.73-7.89-1.57-15.86-4.17-23.36-15-43.32-75-36.45-97.61-76.33-1.78-3.13-3.65-6.75-7.12-7.75-2.27-.66-4.71,0-6.93.84C872.9,296.63,855,304,833.43,312.84c-11.75,4.78-24.81,5.59-36.64,10.19-28.75,11.16-44.79,42.5-50.2,72.86S743.75,457.57,739,488"
        />

        <path
          onClick={onClick}
          name="19"
          style={{ fill: "transparent" }}
          d="M878.31,253.4c5.54-19.71,19.45-41.69,39.86-40.06,11.67.93,21.05,9.55,31.6,14.64,13.29,6.43,28.48,7.21,43.08,9.41,53.2,8,101.09,35.61,151.47,54.49,8.84,3.32,18,6.4,27.43,6.37,4.2,19.19,6,44.08-11.14,53.61-11,6.12-24.73,2.31-36.73-1.63L1071.26,333,892.72,274.4c-6.26-2-13.85-6.07-13.05-12.6"
        />

        <path
          onClick={onClick}
          name="25"
          style={{ fill: "transparent" }}
          d="M1099.39,185c-4.11,2.69-5.64,7.88-6.87,12.63-5.18,20-9.82,43.17,2.4,59.86,8,10.87,21.39,16.22,34.46,19.46,6.34,1.57,13.26,2.73,19.23.07,9.86-4.4,12.75-16.8,14-27.52a417.48,417.48,0,0,0,2.69-54.65c-.13-8-.86-16.89-6.66-22.42-4.62-4.42-11.39-5.6-17.74-6.3-13.69-1.53-29.09-1.25-39.18,8.12"
        />

        <path
          onClick={onClick}
          name="10"
          style={{ fill: "transparent" }}
          d="M702,497a41.14,41.14,0,0,1,27.93,17.93c-.08-4.69,4.2-8.56,8.79-9.53s9.33.29,13.76,1.8c17.93,6.12,35.78,18.36,40,36.82,2.31,10.09.24,20.72,1.95,30.92,1.33,7.91,4.87,15.25,7.76,22.74,14.16,36.62,13,77.11,11.68,116.35-.45,13.21-1,26.73-5.87,39-2.72,6.8-6.79,13.2-7.84,20.46-2.16,14.91,8.61,28.13,16.67,40.87,10,15.78,16.43,33.48,22.81,51,2.76,7.59,5.42,16.49,1.13,23.34s-13.16,8.31-21.06,8.95a300.72,300.72,0,0,1-44.62.28c-1.13,11.48-11.78,21.23-23.32,21.36-16,.17-28-16-30.22-31.93s2.48-31.77,4.67-47.65c4.57-33.15-1.72-66.72-8-99.58q-5.65-29.62-11.29-59.24c-4.1-21.49-8.19-43.69-3.45-65,1.53-6.91,4-13.88,3-20.89-1.08-7.62-6.07-14-9.07-21.12-9.86-23.24,2.36-49.85-.07-75"
        />

        <path
          onClick={onClick}
          name="2"
          style={{ fill: "transparent" }}
          d="M868,838.9l1.71,47.26c.43,12,1,24.55,7,35,5.45,9.54,14.75,16.14,23.76,22.43l18.81,13.13c7.67-10.18,9.51-23.48,11.09-36.13.87-6.9,1.73-13.92.57-20.77s-4.67-13.65-10.7-17.13c-2.25-1.3-4.83-2.13-6.69-3.95-2.63-2.57-3.27-6.51-3.54-10.18a87.66,87.66,0,0,1,1.24-22.35c1.77-9.55,4.69-20.79-2-27.88-7.06-7.53-19.53-4.47-28.89-.11-6.57,3-14.11,9.3-11.29,16"
        />

        <path
          onClick={onClick}
          name="15"
          style={{ fill: "transparent" }}
          d="M1266.1,713.73c-3,12.86,3.41,26.46.72,39.39-1.56,7.48-6,14-9.16,20.94-1,2.18-1.87,4.58-1.38,6.92.73,3.59,4.31,5.79,7.7,7.17,30.6,12.43,65.84-8.1,98-.66,3.48.81,8.37,1.2,9.4-2.22a6.06,6.06,0,0,0-.33-3.58c-2.15-6.65-6.59-12.44-8.34-19.22-2.86-11.06,1.85-22.6,1.81-34,0-4.54-.87-9.26-3.61-12.87-5-6.63-14.46-7.57-22.78-7.8q-34-.94-68.05,1.46"
        />
        <path
          onClick={onClick}
          name="12"
          style={{ fill: "transparent" }}
          d="M1027.66,620a334.86,334.86,0,0,0,.8,35.42,52.39,52.39,0,0,0,17.24,1.35l-.19-35.94c0-7.67-.06-15.54,2.55-22.76,1.9-5.28,5.12-10,8.3-14.58,6.77-9.84,14.07-20.12,24.92-25.1,2-.9,4.09-1.66,5.55-3.25,1.73-1.91,2.17-4.62,2.51-7.17a434.41,434.41,0,0,0,3.32-78.48c-.08-1.84-.25-3.84-1.49-5.2-1.68-1.83-4.54-1.73-7-1.49l-51.76,5a6.41,6.41,0,0,0-3.45,1,6.18,6.18,0,0,0-1.81,3.26c-3.14,10.52-3.18,21.68-3.2,32.65l-.21,119.22"
        />

        <path
          onClick={onClick}
          name="11"
          style={{ fill: "transparent" }}
          d="M1047.9,693.18a115.55,115.55,0,0,0,3.15,39c.62,2.39,1.41,4.92,3.34,6.47a10.32,10.32,0,0,0,4.16,1.78c12.38,2.92,25.63-1.61,35.68-9.39a16.79,16.79,0,0,0,4.75-5.08c2.2-4.08,1.24-9.13-.35-13.49s-3.77-8.65-3.87-13.29c-.12-5.06,2.15-10.64-.64-14.86a11.25,11.25,0,0,0-3.4-3.11,26.08,26.08,0,0,0-20-3.41c-7.7,1.84-14.55,7.2-22.47,7.3"
        />
        <path
          onClick={onClick}
          name="16"
          style={{ fill: "transparent" }}
          d="M1137.9,794a150.35,150.35,0,0,0-93.09,19.38c12.23,12.45,22.56,26.73,35.44,38.51s29.22,21.17,46.67,20.75c-.42,10.41,4,21.36,12.81,27s21.85,4.46,28.24-3.77c4.72-6.09,5.28-14.59,9.83-20.81,6.93-9.48,20.39-10.65,32.13-11,4.22-7.25,4.19-16.41,1.58-24.38s-7.56-15-12.82-21.5c-8.2-10.2-17.59-19.79-29.23-25.78s-25.88-7.95-37.9-2.76"
        />

        <path
          onClick={onClick}
          name="9"
          style={{ fill: "transparent" }}
          d="M1111.48,631.15c3.66-10,14.71-15,25-17.53s21.45-3.73,29.93-10.12c5.43-4.09,9.25-10,14.3-14.51,9.13-8.21,21.55-11.54,33.56-14.11a438,438,0,0,1,141.94-6.67c6.28.74,12.78,1.69,18.08,5.15,3.91,2.54,6.88,6.27,9.77,9.93l18.41,23.26c2.71,3.42,5.55,7.24,5.43,11.6-.17,5.86-5.53,10.1-10.59,13.06-28.63,16.73-63.93,20.92-90.17,41.19-7.69,5.94-14.51,13.2-23.25,17.44-3.24,1.57-6.68,2.68-9.92,4.26-4.28,2.07-8.13,4.91-12.17,7.41-12.48,7.73-28.34,12.25-41.83,6.47-5.37-2.3-10-6.06-15-9a53.15,53.15,0,0,0-48.21-1.95c-8.19,3.85-16,10-25,9.66-9.86-.34-17.8-8.43-22.51-17.1a63.67,63.67,0,0,1,.45-60.53"
        />

        <path
          onClick={onClick}
          name="8"
          style={{ fill: "transparent" }}
          d="M1428,620.64c12.23-24.81,39.73-41.26,67.38-40.29,12,.42,23.6,3.79,35.45,5.42,15.1,2.08,30.44,1.33,45.63,0,14.17-1.27,29.45-2.84,41.72,4.36,7.95,4.66,13.5,12.41,18.82,19.93l12.23,17.32c7.32,10.37,14.59,25,6.36,34.63-2.64,3.11-6.45,4.94-10.14,6.68l-63.93,30.2c-11.37,5.37-23.44,11.36-29.67,22.28-6.57,11.5-5.16,25.8-8.91,38.51-6,20.39-26.87,35.37-48.12,34.58-8.74-.32-17.2-3-25.53-5.65l-82.41-26.27c-2.92-.93-6-1.93-8.12-4.1-2.48-2.47-3.43-6.08-4-9.54-2.41-15.65.87-33.66-9.41-45.7-7.44-8.7-19.91-11.24-31.35-10.94-5.16.13-11.69,0-13.68-4.81-2.15-5.15,3.24-10.14,8-13,35.44-20.85,77.9-31.61,106.23-61.42"
        />
        <path
          onClick={onClick}
          name="17"
          style={{ fill: "transparent" }}
          d="M1587.39,716.83c-10.7,37.18,11.52,80.76,47.9,93.92,12.75,4.62,26.55,5.8,40.08,4.91A137,137,0,0,0,1732.45,799c-2.29,14.25-2.35,32.85,10.94,38.47,12.88,5.45,26.49-7.16,31.82-20.09s7.27-28,17.34-37.75c8.7-8.4,22.66-11.8,27.56-22.86,2.15-4.86,2.11-10.51,4.46-15.28,6-12.22,23.45-12.47,36.52-8.61s27.21,10,39.68,4.47c15-6.63,18.62-25.94,19.59-42.3,1.09-18.43.58-39-12.24-52.33-9.42-9.77-23.45-13.28-36.74-16-44.24-9.12-93.09-13.88-132.07,8.94-20.2,11.82-36,30.14-56,42.22-10.2,6.15-21.33,10.56-32.4,14.95l-57.92,23"
        />

        <path
          onClick={onClick}
          name="5"
          style={{ fill: "transparent" }}
          d="M1814.42,788.32c-1.91,2.22-1.32,5.79.53,8s4.61,3.53,7.28,4.73c3.81,1.71,7.88,3.46,12,2.88a24.69,24.69,0,0,0,5.59-1.76,120,120,0,0,1,65.82-6.28c2.74-5,2.15-11.26-.32-16.36s-6.58-9.21-10.86-12.92a128.58,128.58,0,0,0-45.41-25.36,9.81,9.81,0,0,0-5.33-.59c-2.62.7-4.19,3.3-5.48,5.67q-12.29,22.51-24.55,45"
        />
        <path
          onClick={onClick}
          name="14"
          style={{ fill: "transparent" }}
          d="M1259,398.51,1268.16,526C1348,545.28,1432,520.77,1513.77,529a578.69,578.69,0,0,1-12.52-150.11A2304,2304,0,0,0,1266.16,390"
        />

        <path
          onClick={onClick}
          name="23"
          style={{ fill: "transparent" }}
          d="M1623.53,369a953.67,953.67,0,0,0,5.78,160.45,2063.19,2063.19,0,0,0,225-7.13,1362.07,1362.07,0,0,0,2.73-157.8q-107.92.33-215.76,5.52"
        />

        <path
          onClick={onClick}
          name="18"
          style={{ fill: "transparent" }}
          d="M1598,281.65c-8.36,18.58-1.85,42.65,14.75,54.48s41.46,10.14,56.31-3.82c9.55-9,15.85-22.63,28.4-26.44,4.07-1.24,8.4-1.26,12.65-1.27l100.28-.22c11.59,0,23.49-.11,34.29-4.31s20.43-13.51,21.52-25.05c.62-6.68-1.52-13.94,1.66-19.86,6.11-11.36,23.81-6.75,35.2-12.81,9.92-5.29,13.26-17.64,15.61-28.64,2.15-10.05,4.32-20.36,2.91-30.54s-7.13-20.4-16.65-24.3c-10.79-4.41-22.87.16-34.17,3-23,5.82-47,4.39-70.63,6.07-78.48,5.59-153.55,48-198.88,112.26"
        />
        <path
          onClick={onClick}
          name="21"
          style={{ fill: "transparent" }}
          d="M1504.8,100.46c-1.18,14-2.35,28.34.91,42s11.73,26.93,24.77,32.23c14.14,5.74,30.14,1.23,44.7-3.31l95.36-29.73c8.61-2.68,18-6,22.39-13.91,2.67-4.84,2.93-10.67,2.32-16.17-2.42-22-17-40.35-31-57.42-3.47-4.23-7.11-8.6-12.09-10.87-8.7-4-18.82-.56-27.75,2.87L1514.52,88.4"
        />
      </g>
    </svg>
  );
};
